import { useEffect, useMemo } from 'react'
import styles from './insurance.module.scss'

export const WidgetComponent = () => {
  const memoizedWidgetScript = useMemo(() => {
    if (typeof window !== 'undefined') {
      const script = document.createElement('script')
      script.id = 'tsft-embed-js'
      script.type = 'text/javascript'
      script.src =
        'https://theswiftest.com/wp-content/plugins/tsft-embed/js/tsft-embed.js?offer_id=30&aff_id=87&table_slug=pet-insurance&sub1=example1&sub2=example2&sub3=example3&sub4=example4'
      script.setAttribute('data-eqcss-0-0-next', '')
      script.setAttribute('data-eqcss-1-0-next', '')
      script.setAttribute('data-eqcss-2-0-next', '')
      script.setAttribute('data-eqcss-3-0-next', '')
      return script
    }
    return null
  }, [])

  useEffect(() => {
    const widgetContainer = window?.document?.getElementById('tsft-table-cont')
    if (widgetContainer) {
      widgetContainer.appendChild(memoizedWidgetScript)
    }

    return () => {
      if (
        widgetContainer &&
        memoizedWidgetScript.parentNode === widgetContainer
      ) {
        widgetContainer.removeChild(memoizedWidgetScript)
      }
    }
  }, [memoizedWidgetScript])

  return <div className={styles.widgetSection} id="tsft-table-cont" />
}
